export default "__VITE_ASSET__DxZ4alTT__"